import { cn } from "~/lib/utils"

interface Props {
  className?: string
}

export function UnreadDot({ className }: Props) {
  return <div className={cn("size-2 rounded-full bg-secondary shrink-0 self-center", className)} />
}
